import { Component, Input } from '@angular/core';
import { ImageData } from 'src/app/model/ImageData/ImageData';
import { MapMarker } from 'src/app/model/MapMarker';
import { MediaTypes } from 'src/app/model/MediaTypes';

export interface GalleryItem {
  media?: ImageData;
  map?: MapMarker;
}

@Component({
  selector: 'vrm-gallery-item',
  templateUrl: './gallery-item.component.html',
  styleUrls: ['./gallery-item.component.scss'],
})
export class GalleryItemComponent {
  @Input() item: GalleryItem;

  public readonly mediaTypes: typeof MediaTypes = MediaTypes;
}
